import { Flex, chakra, Image } from '@chakra-ui/react';
import { SliseAd } from '@slise/embed-react';
import React from 'react';

import type { BannerProps } from './types';

import config from 'configs/app';

const SliseBanner = ({ className, platform }: BannerProps) => {
  const currentPath = typeof window !== 'undefined' ? window.location.pathname : '';
  const isHomePage = currentPath === '/' || currentPath === '';
  const bannerConfig = isHomePage ? {
    imageUrl: 'https://pub-3f503cc97e6a45668fbec4d67d6bcb12.r2.dev/Banner_1.png',
    linkUrl: 'https://cards.emoney.io/',
  } : {
    imageUrl: 'https://pub-3f503cc97e6a45668fbec4d67d6bcb12.r2.dev/Banner_2.png',
    linkUrl: 'https://cards.emoney.io/',
  };
  if (platform === 'desktop') {
    return (
      <Flex className={ className } h="90px">
        <a href="https://cards.emoney.io/" target="_blank" rel="noopener noreferrer">
          <Image
            src={ bannerConfig.imageUrl }
            alt="Banner"
            width="728px"
            height="90px"
            objectFit="cover"
            borderRadius="md"
            cursor="pointer"
            _hover={{ opacity: 0.8 }}
          />
        </a>
      </Flex>
    );
  }

  if (platform === 'mobile') {
    return (
      <Flex className={ className } h="90px">
        <SliseAd
          slotId={ config.chain.name || '' }
          pub="pub-10"
          format="270x90"
          style={{ width: '270px', height: '90px' }}/>
      </Flex>
    );
  }

  return (
    <>
      <Flex className={ className } h="90px" display={{ base: 'none', lg: 'flex' }}>
        <SliseAd
          slotId={ config.chain.name || '' }
          pub="pub-10"
          format="728x90"
          style={{ width: '728px', height: '90px' }}/>
      </Flex>
      <Flex className={ className } h="90px" display={{ base: 'flex', lg: 'none' }}>
        <SliseAd
          slotId={ config.chain.name || '' }
          pub="pub-10"
          format="270x90"
          style={{ width: '270px', height: '90px' }}/>
      </Flex>
    </>
  );
};

export default chakra(SliseBanner);
